import { Container, Row } from "react-bootstrap";
import useTenant from "../tenant/useTenant";

const PageContact = () => {
  const tenant = useTenant();

  return (
    <Container>
      <Row className="d-flex justify-content-center align-items-center text-center">
        <div className="col-md-6 mb-2">
          {tenant.contactAddress && <h5>{tenant.contactAddress}</h5>}
          {tenant.contactPhone && <h5>Telefono: {tenant.contactPhone}</h5>}
          {tenant.contactEmail && <h5>{tenant.contactEmail}</h5>}
          <h1>
            {tenant.socialWhatsapp && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={tenant.socialWhatsapp}
              >
                <i className="fa fa-whatsapp"></i>
              </a>
            )}
            {tenant.socialInstagram && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={tenant.socialInstagram}
              >
                <i className="fa fa-instagram"></i>
              </a>
            )}
            {tenant.socialFacebook && (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={tenant.socialFacebook}
              >
                <i className="fa fa-facebook-square"></i>
              </a>
            )}
          </h1>
        </div>
        <div className="col-md-6">
          {tenant.mapIframeSrc && (
            <iframe
              title="My addrees"
              src={tenant.mapIframeSrc}
              width="100%"
              height="400"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen={false}
              aria-hidden="false"
              tabIndex={0}
            ></iframe>
          )}
        </div>
      </Row>
    </Container>
  );
};

export default PageContact;
